import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import ReactTooltip from "react-tooltip"
import styled from "styled-components"
import { translate } from "react-i18next"
import uniqid from "uniqid"

const SampleSizeButton = styled.a`
  font-size: 1.1em;
  color: #ff2a00 !important;
  padding: 5px;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  left: 5px;
  z-index: 100;
  float: left;
`

class SampleSizeWarning extends Component {
  static propTypes = {
    sampleSize: PropTypes.object
  }

  componentWillMount = () => {
    // Create a unique id for the tooltips to use
    const uniqueId = uniqid()
    this.sampleSizeTooltipId = `${uniqueId}_sst`
  }

  includeFiguresInSampleSizeWarning = (translation, sample, total) => {
    if (!translation) return ""
    var text = translation.replace("{sample}", sample)
    text = text.replace("{total}", total)
    return text
  }

  render() {
    const { sampleSize, t } = this.props

    return (
      <Fragment>
        {sampleSize &&
          (sampleSize.showWarning || sampleSize.dobWarning) && (
            <Fragment>
              <SampleSizeButton
                className="show-on-card-hover"
                data-tip
                data-for={this.sampleSizeTooltipId}
                data-offset="{'bottom': 7, 'right': 10}"
              >
                <i className="fa fa-exclamation-triangle" />
              </SampleSizeButton>
              <div className="clearfix" />
              <ReactTooltip id={this.sampleSizeTooltipId} effect="solid" place="bottom">
                {!sampleSize.hireDateWarning && (
                  <div>
                    {this.includeFiguresInSampleSizeWarning(
                      t("Errors.SampleSizeWarning"),
                      sampleSize.sample,
                      sampleSize.total
                    )}
                  </div>
                )}
                {sampleSize.showWarning &&
                  sampleSize.hireDateWarning && (
                    <div>
                      {this.includeFiguresInSampleSizeWarning(
                        t("Errors.SampleSizeHiredDateWarning"),
                        sampleSize.sample,
                        sampleSize.total
                      )}
                    </div>
                  )}
                {sampleSize.dobWarning && (
                  <div>
                    {this.includeFiguresInSampleSizeWarning(
                      t("Errors.SampleSizeDobWarning"),
                      sampleSize.invalidDobSample,
                      sampleSize.total
                    )}
                  </div>
                )}
              </ReactTooltip>
            </Fragment>
          )}
      </Fragment>
    )
  }
}

export default translate()(SampleSizeWarning)



// WEBPACK FOOTER //
// ./src/components/layout/widget/SampleSizeWarning.jsx